import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter as Router, Switch, Route, Redirect, useHistory } from "react-router-dom";

import Login from "./pages/login/Login";
import Sidebar from "./components/sidebar/Sidebar";
import Topbar from "./components/topbar/Topbar";
import Signup from "./pages/signup/Signup.jsx";

import Home from "./pages/home/Home";
import UserList from "./pages/userList/UserList";
import User from "./pages/user/User";
import UserTeams from "./pages/userTeams/UserTeams";
import Team from "./pages/team/Team";
import UserSubscriptionDetails from "./pages/userSubscriptionDetails";
import NewUser from "./pages/newUser/NewUser";
import GameRules from "./pages/gameRules/GameRules";
import RuleDetails from "./pages/ruleDetails/RuleDetails";
import AddRule from "./pages/addRule/AddRule";
import EditUser from "./pages/editUser/EditUser";
import AllSubscriptions from "./pages/allSubscriptions/AllSubscriptions";
import SubscriptionBundles from "./pages/subscriptionBundles/SubscriptionBundles";
import CreateBundle from "./pages/createBundle/CreateBundle";
import UpdateBundle from "./pages/updateBundle/UpdateBundle";
import GameCodes from './pages/gameCodes/GameCodes.jsx';
import StatsPage from "./pages/statsPage/StatsPage.jsx";
import StatsDetails from "./pages/statsDetails/StatsDetails.jsx";

import UserDashboard from "./user/pages/dashboard/UserDashboard.jsx"
import SelectTeam from "./user/pages/selectTeam/SelectTeam.jsx"
import GameLog from "./user/pages/gamelog/GameLog.jsx"
import GameLogDetails from "./user/pages/gamelogdetails/GameLogDetails.jsx"
import MyTeam from "./user/pages/myTeams/MyTeam.jsx"
import EditTeam from "./user/pages/editTeam/EditTeam.jsx"
import ScheduledGameDetails from "./user/pages/scheduledGameDetails/scheduledGameDetails.jsx";
import EditScheduledGame from "./user/pages/editScheduledGame/editScheduledGame.jsx";
import Opponents from "./user/pages/opponents/Opponents.jsx";
import OppRoster from './user/pages/opp&Roster/oppRoster.jsx'
import EditOppTeam from './user/pages/editOppTeam/EditOppTeam.jsx'
import CreateTeam from './user/pages/createTeam/CreateTeam.jsx'
import Settings from './user/pages/settings/Settings.jsx'
import TechnicalFoulSetting from './user/pages/settingPenaltyDescription/TechnicalFoulSettings.jsx'
import PersonalFoulSetting from './user/pages/settingPenaltyDescription/PersonalFoulSettings.jsx'
import PenaltyTimingSettings from './user/pages/settingPenaltyDescription/PenaltyTimingSettings'
import SettingsRatings from './user/pages/settingRatings/SettingsRatings.jsx'
import Invitation from "./pages/invitation/invitation.jsx";
import AccountSettings from "./user/pages/accSettings/accSettings.jsx";
import "./App.css";
import AccountSharing from "./user/pages/accSharing/accSharing.jsx";
import UserSidebar from "./components/userSiderbar/userSidebar.jsx";
import SelectAccount from "./selectAcc/selectAcc.jsx";
import EditAccInfo from "./user/pages/editUserInfo/editUserInfo.jsx";
import SettingTurnoverDescription from "./user/pages/settingTurnoverDescription/settingTurnoverDescription.jsx";
import CreateOpponentTeam from "./user/pages/createOppTeam/createOppTeam.jsx";
import ChangeTeamRule from "./user/pages/changeTeamRule/changeTeamRule.jsx";
import SettingRule from "./user/pages/settingRule/settingRule.jsx";

function App() {
  const { isAuthenticated, isAdmin } = useSelector((state) => state.auth);
  const history = useHistory();
  const redirectPath = useSelector((state) => state.team.shouldRedirectTo);

  useEffect(() => {
    if (redirectPath) {
      history.push(redirectPath);
    }
  }, [redirectPath, history]);

  return (
    <Router>

      {isAuthenticated ? (
        <>
          <Topbar />
          <div style={{ display: 'flex' }}>
            {isAdmin && <Sidebar />}
            <Switch>
              {/* Authenticated Routes */}
              <Route exact path="/" component={UserDashboard} />
              <Route path="/userlist" component={UserList} />
              <Route path="/user/:userId" component={User} />
              <Route path="/userTeams/:userId" component={UserTeams} />
              <Route path="/team/:subscriptionId" component={Team} />
              <Route path="/UserSubscriptionDetails/:subId" component={UserSubscriptionDetails} />
              <Route path="/newUser" component={NewUser} />
              <Route path="/gameRules" component={GameRules} />
              <Route path="/ruleDetails/:ruleId" component={RuleDetails} />
              <Route path="/addRule" component={AddRule} />
              <Route path="/editUser/:userId" component={EditUser} />
              <Route path="/allSubscriptions" component={AllSubscriptions} />
              <Route path="/subscriptionBundles" component={SubscriptionBundles} />
              <Route path="/createBundle" component={CreateBundle} />
              <Route path="/updateBundle/:id" component={UpdateBundle} />
              <Route path="/gamecodes" component={GameCodes} />
              <Route path="/stats/:category" component={StatsPage} />
              <Route path="/statsDetails/:stats" component={StatsDetails} />
              <Route path="/userdashboard" component={UserDashboard} />
              <Route path="/selectteam" component={SelectTeam} />
              <Route exact path="/gamelog" component={GameLog} />
              <Route path="/gamelog/:logId" component={GameLogDetails} />
              <Route exact path="/myteam" component={MyTeam} />
              <Route exact path="/editteam" component={EditTeam} />
              <Route path="/editscheduledgame/:gameId" component={EditScheduledGame} />
              <Route path="/opponents" component={Opponents} />
              <Route path="/opproster" component={OppRoster} />
              <Route exact path="/editoppteam/:teamId" component={EditOppTeam} />
              <Route path="/createteam" component={CreateTeam} />
              <Route path="/settings" component={Settings} />
              <Route path="/TechnicalFoulsettings" component={TechnicalFoulSetting} />
              <Route path="/PersonalFoulsettings" component={PersonalFoulSetting} />
              <Route path="/PenaltyTimingSettings" component={PenaltyTimingSettings} />
              <Route path="/settingsratings" component={SettingsRatings} />
              <Route path="/accountsettings" component={AccountSettings} />
              <Route path="/accountsharing" component={AccountSharing} />
              <Route path="/selectaccount" component={SelectAccount} />
              <Route path="/editaccountinfo" component={EditAccInfo} />
              <Route path="/settingTurnoverDescription" component={SettingTurnoverDescription} />
              <Route path="/createopponentteam" component={CreateOpponentTeam} />
              <Route path="/teamrules" component={ChangeTeamRule} />
              <Route path="/rulessettings" component={SettingRule} />

              <Route path="/signup" component={Signup} />
              <Redirect to={isAdmin ? "/" : "/selectteam"} />
            </Switch>
          </div>
        </>
      ) : (
        <Switch>
          {/* Unauthenticated Routes */}
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Signup} />
          <Route path="/invitation" component={Invitation} />
          <Redirect to="/login" />
        </Switch>
      )}
    </Router>
  );
}

export default App;
